<div
  class="textarea-container relative mt-4 group rounded-t-md"
  [ngClass]="{
    'border-t-red-600 border-r-red-600 border-l-red-600 border':
      showError && !valor()
  }"
>
  <textarea
    id="input"
    class="rounded-none rounded-t-md focus:shadow-none"
    [(ngModel)]="valor"
    (focus)="show = true"
    (blur)="show = false; trim()"
    [readOnly]="readonly"
    [rows]="rows ?? ''"
    [ngClass]="{
      'h-40': alto
    }"
  ></textarea>
  <label
    class="label absolute top-2.5 left-0 pointer-events-none"
    [ngClass]="{ 'label-focus': show || valor() }"
  >
    {{ etiqueta }}
  </label>
  <label
    class="place absolute pl-2 top-2.5 left-0 pointer-events-none group-focus-within:opacity-100 opacity-0"
    [ngClass]="{ 'place-focus': valor() }"
  >
    {{ placeholder }}
  </label>
  <div class="underline" [ngClass]="{ 'underline-focus': show }"></div>
</div>
<div class="hide" [ngClass]="{ show: showError && !valor() }">
  <div>
    <small class="flex justify-start items-center text-red-600 mt-1">
      <svg
        width="10px"
        height="10px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="mr-0.5"
      >
        <path
          d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
          stroke="#dc2626"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
          stroke="#dc2626"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      {{ mensajeError }}
    </small>
  </div>
</div>
